import React from "react";
import { TextField, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomSearch = ({ searchQuery, setSearchQuery }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // màn hình nhỏ hơn 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // tablet

  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder={isMobile ? "Search..." : "Search product..."} // mobile ngắn gọn hơn
      size={isMobile ? "small" : "medium"}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{
        maxWidth: isMobile ? "100%" : isTablet ? "400px" : "500px", // mobile 100%, tablet 400px, desktop 500px
        marginBottom: isMobile ? "8px" : "16px",
        "& .MuiOutlinedInput-root": {
          fontSize: isMobile ? "0.8rem" : "0.9rem",
          "& fieldset": { borderColor: "#ccc" },
          "&:hover fieldset": { borderColor: "#1976d2" },
          "&.Mui-focused fieldset": {
            borderColor: "#1976d2",
            borderWidth: "2px",
          },
        },
      }}
    />
  );
};

export default CustomSearch;
